module.exports = __webpack_public_path__ + "img/box1_icon6.2e55eabd.png";